<template>
    <reconciliation-step-template 
        :nextStep="nextStep" 
        :previousStep="previousStep" 
        @next="goToNextStep"
        @previous="$emit('previous')">
        
        <template #content>
            <h3>{{ $l10n.__("Débit") }}</h3>
            <p class="fs-3">{{ $l10n.__("Sélectionnez la colonne des débits") }}</p>
            <div class="step-container-table border-black">
                <table-selectable-columns 
                    :lines="csv"
                    v-model="value.template.amount_debit.columns"
                    :max="1"
                />
            </div>
        </template>
    </reconciliation-step-template>
</template>

<script>
    import TableSelectableColumns from 'vcomponents/utilities/TableSelectableColumns.vue'
    import ImportStepsMixins from './ImportStepsMixins'
    export default {
        mixins: [ImportStepsMixins],
        data(){
            return {
            }
        },
        created(){
            this.checkPreviousSteps()
        },
        methods: {
            goToNextStep(){
                this.checkMinColumns('amount_debit', 1) ? this.$emit('next') : false
            }
        },
        components: {
            TableSelectableColumns
        }
    }
</script>

<style scoped>

</style>
